module.exports = __webpack_public_path__ + "static/media/icon_tr.11b07e28.svg";